import { Card, CardContent, Theme } from '@mui/material';
import { useCurrentFile } from 'shared/Providers/CurrentFile'
import { useEditDocumentContext } from 'shared/hooks/use-edit-document'
import { useFormik } from 'formik'
import { DOC_TYPE_FILE_FINISH_VIDEO, TDocFile } from 'shared/constants/docs'
import { FormTextField } from 'shared/_ui/form/form-text-field'
import { useUserContext } from 'shared/Providers/User'
import YoutubePlayer from 'shared/components/YoutubePlayer/YoutubePlayer'
import { FormTagField } from 'shared/_ui/form/form-tag-field'

export default function FileMetadata({ formik }: {
	// TODO: fix type. This brings an error on webapp build
	// formik: ReturnType<typeof useFormik<TDocFile>>;
	formik: ReturnType<typeof useFormik>;
}) {
	const { file } = useCurrentFile();
	const { permissions: { canPublishMedia } } = useUserContext();
	const { isEdit } = useEditDocumentContext();

	return (
		<Card>
			<CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
				{canPublishMedia &&
					file.type === DOC_TYPE_FILE_FINISH_VIDEO &&
					(!isEdit && file.youtube && file.youtube.youtubeId ? (
						<YoutubePlayer
							sx={(theme: Theme) => ({
								borderRadius: theme.spacing(2),
								aspectRatio: '16 / 9',
								width: '100%',
							})}
							youtubeId={file.youtube.youtubeId}
						/>
					) : (
						<FormTextField
							label="Youtube Id:"
							name="youtube.youtubeId"
							fullWidth
							formik={formik}
							labelProps={{ width: '4.75rem' }}
							spellCheck
							readOnly={!isEdit}
						/>
					))}
				<FormTextField
					label="Title:"
					name="title"
					fullWidth
					formik={formik}
					labelProps={{ width: '4.75rem' }}
					spellCheck
					readOnly={!isEdit}
				/>
				<FormTextField
					label="Description:"
					name="description"
					fullWidth
					formik={formik}
					labelProps={{ width: '4.75rem' }}
					multiline
					placeholder="Add notes about your file"
					spellCheck
					readOnly={!isEdit}
					// onReadOnlyClick={handleEnableEdit}
				/>
				<FormTagField
					label="Keywords:"
					name="keywords"
					fullWidth
					formik={formik}
					labelProps={{ width: '4.75rem' }}
					readOnly={!isEdit}
					// onReadOnlyClick={handleEnableEdit}
					// showCopyButton // TODO: Implement copy tags functionality
				/>
			</CardContent>
		</Card>
	);
}
